import React from 'react';
import { SettingRow } from './SettingRow';
import { useSettingsConfig } from '../hooks/useSettingsConfig';

export function SettingsTabContent() {
    const { selectedSection } = useSettingsConfig()
    if (!selectedSection) return null

    return (
        <div className="w-full max-w-5xl">
            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                <div className="px-4 py-3">
                    <div className="flex flex-col gap-2">
                        {selectedSection.options.map((option, index) => <SettingRow key={index} option={option} />)}
                    </div>
                </div>
            </div>
        </div>
    );
} 